import type { Language } from "../../types/i18n";
import {
  healthConditionsStrings,
  type HealthConditionsStrings,
} from "./healthConditions";
import {
  healthAllergiesMedsStrings,
  type HealthAllergiesMedsStrings,
} from "./healthAllergiesMeds";
import { healthPageStrings, type HealthPageStrings } from "./healthPage";
import { healthMoreStrings, type HealthMoreStrings } from "./healthMore";
import { appPagesStrings, type AppPagesStrings } from "./appPages";
import { formattingStrings, type FormattingStrings } from "./formatting";

/*
 * Area modules keep translations.ts from growing past what anyone can edit.
 * Each module owns a disjoint set of flat keys; translations.ts spreads them
 * into every language, and `Translation` extends `ModuleStrings`, so a key
 * defined both here and in translations.ts is a type error, not a silent
 * override.
 */
export type ModuleStrings = HealthConditionsStrings &
  HealthAllergiesMedsStrings &
  HealthPageStrings &
  HealthMoreStrings &
  AppPagesStrings &
  FormattingStrings;

const modules = [
  healthConditionsStrings,
  healthAllergiesMedsStrings,
  healthPageStrings,
  healthMoreStrings,
  appPagesStrings,
  formattingStrings,
] as const;

export function moduleStrings(language: Language): ModuleStrings {
  return Object.assign({}, ...modules.map((m) => m[language])) as ModuleStrings;
}
